import React from 'react';
import { isVideo } from '../../utils/media';
import ImageDisplay from '../ImageDisplay/ImageDisplay';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { isShortFormVideo } from './utils/mediaFilter';
import { ModalContainer, ModalContent, CloseButton, MediaCounter, MediaViewer, VideoViewerContainer, ShortFormIndicator, ImageContainer, NavButton, IndicatorsContainer, IndicatorsBar, Indicator } from './styles/index';
/**
 * 미디어 모달 컴포넌트
 * 전체 화면으로 미디어를 보여주는 모달
 */ var MediaModal = function(param) {
    var isOpen = param.isOpen, displayableMedia = param.displayableMedia, activeIndex = param.activeIndex, setActiveIndex = param.setActiveIndex, onClose = param.onClose, onNext = param.onNext, onPrev = param.onPrev;
    if (!isOpen || displayableMedia.length === 0) return null;
    var currentMedia = displayableMedia[activeIndex];
    var isVideoMedia = (currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.type) === 'video' || !(currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.type) && isVideo((currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.url) || '');
    var totalCount = displayableMedia.length;
    // 모달 내부 클릭 이벤트 전파 방지
    var handleModalContentClick = function(e) {
        e.stopPropagation();
    };
    return /*#__PURE__*/ React.createElement(ModalContainer, {
        isOpen: isOpen,
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(CloseButton, {
        type: "button",
        onClick: onClose,
        "aria-label": "닫기"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    }))), /*#__PURE__*/ React.createElement(MediaCounter, null, activeIndex + 1, " / ", totalCount), /*#__PURE__*/ React.createElement(ModalContent, {
        onClick: handleModalContentClick
    }, /*#__PURE__*/ React.createElement(MediaViewer, null, isVideoMedia ? /*#__PURE__*/ React.createElement(VideoViewerContainer, {
        isShortForm: isShortFormVideo(currentMedia)
    }, isShortFormVideo(currentMedia) && /*#__PURE__*/ React.createElement(ShortFormIndicator, null, "숏폼"), /*#__PURE__*/ React.createElement(VideoPlayer, {
        src: (currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.url) || '',
        controls: true,
        autoPlay: false,
        muted: false,
        loop: false,
        fileBlob: currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.file
    })) : /*#__PURE__*/ React.createElement(ImageContainer, null, /*#__PURE__*/ React.createElement(ImageDisplay, {
        src: (currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.url) || '',
        alt: "미디어 ".concat(activeIndex + 1),
        imageBlob: currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.file,
        fallbackSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII="
    }))), displayableMedia.length > 1 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NavButton, {
        type: "button",
        direction: "left",
        onClick: function(e) {
            e.stopPropagation();
            onPrev(e);
        },
        "aria-label": "이전 미디어"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("polyline", {
        points: "15 18 9 12 15 6"
    }))), /*#__PURE__*/ React.createElement(NavButton, {
        type: "button",
        direction: "right",
        onClick: function(e) {
            e.stopPropagation();
            onNext(e);
        },
        "aria-label": "다음 미디어"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("polyline", {
        points: "9 18 15 12 9 6"
    })))), displayableMedia.length >= 3 && /*#__PURE__*/ React.createElement(IndicatorsContainer, null, /*#__PURE__*/ React.createElement(IndicatorsBar, null, displayableMedia.map(function(item, idx) {
        return /*#__PURE__*/ React.createElement(Indicator, {
            key: "thumbnail-".concat(idx),
            type: "button",
            isActive: idx === activeIndex,
            onClick: function(e) {
                e.stopPropagation();
                setActiveIndex(idx);
            },
            "aria-label": "".concat(idx + 1, "번 미디어로 이동")
        });
    })))));
};
export default MediaModal;
